import React, { Component } from 'react';

import renderHTML from 'react-render-html';

class TabItem extends Component {

	constructor() {
        super();

        this.state = {
            class: ''
        };
	}

    componentDidMount() {
        this.setState({ class: 'tabs__item--' + this.props.color });
    }

    componentWillUnmount() {
    }

	render() {
        const itemActive = (this.props.active) ? "tabs__item--active" : "";
        var classList = [
            "tabs__item",
            itemActive,
            this.state.class
        ];

        return (
            <div className={ classList.join(' ') } onClick={ this.props.onClick }>
                { renderHTML(this.props.content) }
            </div>
    	);
	}
}

export { TabItem };